import React from "react";
import {
  ChevronRightIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import { cn } from "../../../../../utils/Cn";

export const BankSelect = ({
  onSelect,
  error,
  displayedInstitutions,
  searchTerm,
  onSearchTermChange,
  processing = false,
}) => {
  const handleSelect = (institution) => {
    if (processing) return; // Prevent multiple selections during processing

    onSelect(institution);
  };

  return (
    <>
      <div className="relative">
        <MagnifyingGlassIcon
          className="absolute left-3 top-1/2 -translate-y-1/2 size-5 text-zinc-500 pointer-events-none"
          strokeWidth={1.5}
        />
        <input
          className="w-full rounded-xl py-3 pl-9 pr-3 text-sm font-light bg-white outline-none focus:ring-2 focus:ring-inset focus:ring-blue-800 focus:border-transparent border border-zinc-200 shadow-xs"
          value={searchTerm}
          onChange={(e) => onSearchTermChange(e.target.value)}
          placeholder="Search"
          disabled={processing}
        />
      </div>
      {error && (
        <p className="px-2 pt-4 pb-2 text-red-500 text-sm">
          There was an error with your chosen bank
        </p>
      )}
      <div className="relative mt-2 overflow-x-visible">
        <div className="flex flex-col gap-2 mb-4 relative py-2 pb-6">
          {displayedInstitutions &&
            displayedInstitutions.map((x) => (
              <button
                key={x.id}
                role="button"
                onClick={() => handleSelect(x)}
                disabled={processing}
                className={cn(
                  "bg-white pl-3 py-3 pr-5 rounded-xl flex items-center justify-between gap-3 h-14 cursor-pointer border border-zinc-200 transition-all shadow-xs",
                  processing
                    ? "opacity-50 cursor-not-allowed"
                    : "hover:bg-zinc-50"
                )}
              >
                <div className="flex items-center gap-3">
                  <img
                    className="size-8 rounded-full"
                    src={x.iconUrl}
                    alt={x.name}
                  />
                  <span className="text-sm flex-1 text-left">{x.name}</span>
                </div>
                <ChevronRightIcon className="size-3.5" strokeWidth={3} />
              </button>
            ))}
        </div>
      </div>
    </>
  );
};
